module.exports = __webpack_public_path__ + "img/NOYA_01.f4f37616.jpg";